// @flow

import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { isMobile } from 'react-device-detect'
import { LoadingAnimation } from '../../components'
import {
	AppWrapper,
	Categories,
	Products,
	ProceedToCheckout,
	WebProductDetail,
} from '../../containers'
import { ANALYTICS_HELPER, HELPER, IMAGE_SRC } from '../../utils'

function Shop() {
	const { config, inventory, loading } = useSelector((state) => state)
	const { browseStores, merchant_banner_settings, merchant } = config
	const { showLoadingScreen } = loading
	const { products, categories } = inventory

	useEffect(() => {
		ANALYTICS_HELPER._screenShift(ANALYTICS_HELPER.EVENT_STEPS.SHOP, ANALYTICS_HELPER.CATEGORY.SHOP)
	}, [])

	return (
		<AppWrapper
			showBackIcon={browseStores}
			observeBackHistory={true}
			showLangIcon={true}
			showCartIcon={true}
			showAccountDropdown={true}
		>
			{showLoadingScreen ? (
				<LoadingAnimation />
			) : (
				<>
					{!isMobile ? <WebProductDetail /> : ''}
					{!merchant?.under_construction && !HELPER.isEmpty(merchant_banner_settings?.banner) ? (
						<>
							{!HELPER.isEmpty(merchant?.banner_text) ? (
								<div className="shopAreaBasedShipmentBanner">
									<div className="insideShopAreaBasedShipmentBanner">
										<div className="insideShopAreaBasedShipmentBannerText">
											{merchant?.banner_text}
										</div>
									</div>
								</div>
							) : (
								''
							)}
							<div className="shopCatBanner">
								<div className="insideShopCatBanner">
									<img src={merchant_banner_settings?.banner} alt="" />
								</div>
							</div>
						</>
					) : merchant?.under_construction ? (
						<div className="underConstruction">
							<img src={IMAGE_SRC.UNDER_CONSTRUCTION} alt="Under construction" />
							<p>Under Construction / Maintenance</p>
						</div>
					) : (
						''
					)}
					<div className="catalogContentWrap shopContentWrap">
						{/* Categories */}
						{!HELPER.isEmpty(categories) ? <Categories /> : ''}
						{/* Categories */}
						{/* Products */}
						{!HELPER.isEmpty(products) ? <Products /> : ''}
						{/* Products */}
						<div className="proceedToCheckoutWrap">
							<ProceedToCheckout />
						</div>
					</div>
				</>
			)}
		</AppWrapper>
	)
}

export default Shop
